exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".editor-DropZone{position:fixed;left:0;top:0;width:100%;height:100%;color:#fff;z-index:106}.editor-DropZone .editor-DropZone-body{display:table;width:100%;height:100%;background-color:rgba(0,0,0,.85)}.editor-DropZone .editor-DropZone-center{display:table-cell;vertical-align:middle;text-align:center}.editor-DropZone p{font-size:1.5rem;font-weight:700}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./editor/legacy/Dropzone.less
 ** module id = 896
 ** module chunks = 1
 **/